import theme from "@/theme";
import { SVGProps } from "react";
const UnlockPremiumSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} fill="none" {...props}>
    <path
      stroke={theme.palette.custom.mainBlue}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.584 19.251H6.417a1.833 1.833 0 0 1-1.833-1.833v-6.417c0-1.013.82-1.833 1.833-1.833h9.167c1.013 0 1.833.82 1.833 1.833v6.417c0 1.013-.82 1.833-1.833 1.833Z"
      clipRule="evenodd"
    />
    <path
      stroke={theme.palette.custom.mainBlue}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.668 6.417A3.667 3.667 0 0 0 11 2.75a3.66 3.66 0 0 0-3.544 2.771M14.667 9.168v-2.75"
    />
  </svg>
);
export default UnlockPremiumSvg;
